import { isExternalLlm, MODEL_TO_LITELLM_MODELS } from '@kindo/universal';

import SettingsSection from '../../SettingsSection';

import { Table, Typography, TypographySize } from '~/components/core';
import { useGetAllAvailableOrgModels } from '~/hooks';

const AvailableModels = () => {
  const { allAvailableOrgModels: models } = useGetAllAvailableOrgModels();

  return (
    <SettingsSection title="Available Models">
      <div
        className="my-6 flex flex-col"
        data-testid="available-models-container"
      >
        <Table
          columns={[
            {
              title: 'Name',
              width: 'w-1/3'
            },
            {
              title: 'API Model Name',
              width: 'w-2/3'
            }
          ]}
          noRowsText="No models currently available."
          rows={models.map((model) => {
            const modelDisplayName = model.displayName;
            const modelIdentifier = model.identifier;
            return {
              key: `${modelIdentifier}-info-row`,
              cells: [
                // Model Title
                <div
                  className="flex flex-col gap-2"
                  data-testid="model-name-container"
                  key={`${modelIdentifier}-title`}
                >
                  <Typography size={TypographySize.SMALL}>
                    {modelDisplayName}
                  </Typography>
                </div>,
                // Model Name
                <Typography
                  key={`${modelIdentifier}-name`}
                  size={TypographySize.SMALL}
                >
                  {isExternalLlm(modelIdentifier)
                    ? MODEL_TO_LITELLM_MODELS[modelIdentifier]
                    : modelIdentifier}
                </Typography>
              ]
            };
          })}
        />
      </div>
    </SettingsSection>
  );
};

export default AvailableModels;
